import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Link from '../../../components/Link';
import { Sprawy } from '../../sprawy/Sprawy';
import s from '../../content.scss';
import { fetchGraves, fetchGraveyard, fetchSectors } from '../../../actions/district';
import PaperTile from '../../../components/PaperTile/PaperTile';
import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { notFoundImageURL } from '../../../config';
import Stepper, { Step } from '../../../components/Stepper';
import fetch from '../../../core/fetch';
import godloPolski from './godlo-Polski.png';
import Select from 'react-select';
import waiting from '../images/waiting-wheel-300x300.gif';

const isBrowser = typeof window !== 'undefined' && window !== null;
let Map, TileLayer, L, WMSTileLayer, Rectangle, GeoJSON, Pan, MyPan, Popup, localStorage;

if (isBrowser) {
  Map = require('react-leaflet/lib/Map').default;
  TileLayer = require('react-leaflet/lib/TileLayer').default;
  WMSTileLayer = require('react-leaflet/lib/WMSTileLayer').default;
  Rectangle = require('react-leaflet/lib/Rectangle').default;
  GeoJSON = require('react-leaflet/lib/GeoJSON').default;
  Popup = require('react-leaflet/lib/Popup').default;
  L = require('leaflet');
  localStorage = window.localStorage;
}

const gorzycaBounds = {
  maxx: 14.8175,
  maxy: 52.5759,
  minx: 14.6038,
  miny: 52.4224,
};
let mapBounds;

const bounds = gorzycaBounds; //cordy na start


// const CalculateCenter = bounds => {
//   return  [(bounds.maxy + bounds.miny) / 2, (bounds.maxx + bounds.minx) / 2];
// }

// const getCenterAsObj = bounds => {
//   return { lat: (bounds.maxy + bounds.miny) / 2, lng: (bounds.maxx + bounds.minx) / 2 };
// }

// zmienna przechowująca wszystkie groby
let arr = [];

class Cmentarze extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bounds: bounds,
      center: null,
      prefix: this.props.prefix,
      isMounted: false,
      graveyard: null,
      graves: null,
      selected: {
        "features": [],
        "type": "FeatureCollection"
      },
      znicz: false,
      label: { label: 'wyszukaj...' },
      sectors: null,
    }
  }
  componentWillMount() {
    console.warn(this.props.prefix)
    this.props.fetchGraves(this.props.prefix);
    this.props.fetchGraveyard(this.props.prefix);
    this.props.fetchSectors(this.props.prefix);
  }
  componentDidMount() {
    this.setState({
      isMounted: true,
    });
  }
  componentWillReceiveProps(nextProps) {

    if (JSON.stringify(this.state.graves) !== JSON.stringify(nextProps.graves)) {
      arr = [];
      nextProps.graves.features.map((e, i) => {
        arr.push({
          latlng: [e.geometry.coordinates[0], e.geometry.coordinates[1]],
          imie: e.properties.imie,
          nazwisko: e.properties.nazwisko,
          dataZgonu: e.properties.data_zgonu,
          pkuid: e.properties.PK_UID,
          cmentarz: e.properties.cmentarz,
          id: e.properties.id,
          id_cm: e.properties.id_cm,
          id_rodzaj: e.properties.id_rodzaj,
          id_rzedu: e.properties.id_rzedu,
          id_sekt: e.properties.id_sekt,
          id_typ: e.properties.id_typ,
          id_wlk: e.properties.id_wlk,
          nr_ewid: e.properties.nr_ewid,
          nr_rej_zab: e.properties.nr_rej_zab,
          uwagi: e.properties.uwagi,
          label: `${e.properties.imie} ${e.properties.nazwisko} (Data zgonu: ${e.properties.data_zgonu})`
        });
      });

      Array.prototype.max = function() {
        return Math.max.apply(null, this);
      };

      Array.prototype.min = function() {
        return Math.min.apply(null, this);
      };
      let x = [];
      let y = [];
      if (nextProps.graveyard.features) {
        nextProps.graveyard.features.map(v => {
          v.geometry.coordinates[0].map(i => {
            x.push(i[0]);
            y.push(i[1]);
          });
        });
      }
      const xmin = Math.min.apply(null, x);
      const xmax = Math.max.apply(null, x);
      const ymin = Math.min.apply(null, y);
      const ymax = Math.max.apply(null, y);
      mapBounds = [[ymin, xmin], [ymax, xmax]];
      this.mapka.leafletElement.fitBounds(mapBounds);

      this.setState({
        graveyard: nextProps.graveyard.features,
        center: L.geoJson(nextProps.graveyard.features).getBounds().getCenter(),
      });
    }
    if (JSON.stringify(this.state.graves) !== JSON.stringify(nextProps.graves)) {
      this.setState({
        graves: nextProps.graves,
      });
    }
    if (JSON.stringify(this.state.graveyard) !== JSON.stringify(nextProps.graveyard)) {
      this.setState({
        graveyard: nextProps.graveyard,
      });
    }

    if (JSON.stringify(this.state.sectors) !== JSON.stringify(nextProps.sectors)) {
      if (nextProps.sectors.features){
        nextProps.sectors.features.map((v, i) => {
          v.geometry.coordinates.map((b, j) => {
            b.map((n, k) => {
              let temp = n[0];
              n[0] = n[1];
              n[1] = temp;
            })
          })
        })
      }
      this.setState({
        sectors: nextProps.sectors,
      });
    }
  }

  handleGrave = (e) => {
    let zmienna;
    let znicz = false;

    // gdy kasujemy wybor
    if (e === null) {
      this.setState({
        selected: {
          ...this.state.selected,
          features: [],
        },
        znicz: false,
        label: ``
      }, () => {
        this.mapka.leafletElement.fitBounds(mapBounds);
      }

    );

    } else {
      // wybieramy grob
      this.state.graves.features.map((v, i) => {
        if (e.id === v.properties.id) return zmienna = v;
      });
      const graveId = `grob_${zmienna.properties.id}`;

      if (localStorage.getItem(graveId) === 'zapalony') {
        znicz = true;
      } else {
        znicz = false;
      }

      // walczymy z server side renderingiem i resetujemy warstwe
      if (this.markery) {
        this.markery.leafletElement.clearLayers();
      }

      // resetujemy dane
      this.setState({
        selected: {
          ...this.state.selected,
          features: [],
        },
        znicz: false,
        label: '',
      }, () => {
        // podajemy dane nowo wybranego grobu (zaraz po zresetowaniu tego state)
        this.setState({
          selected: {
            ...this.state.selected,
            features: [zmienna],
          },
          znicz: znicz,
          label: { label: `${zmienna.properties.imie} ${zmienna.properties.nazwisko} (Data zgonu: ${zmienna.properties.data_zgonu})` },
        }, () => {
          // po wybraniu grobu lecimy mapą do tego punktu
          const kordy = [zmienna.geometry.coordinates[1], zmienna.geometry.coordinates[0]]; // musimy odwrocic cordy bo afrika to troche nie to
          this.mapka.leafletElement.flyTo(kordy, 17);
        },
      );
      },
      );
    }
  }
  selectedGrave = () => {
    let handler;
    if (this.state.selected.features.length !== 0) {
      return handler = this.state.selected.features[0].properties;
    }
    return handler;
  };

  graveyardStyle = (feature, layer) => {
    return {
      color: '#c300ff',
      weight: 3,
      opacity: 0.9,
      zIndex: '1000',
    };
  };

  rzadStyle = (feature, layer) => {
    return {
      color: '#000',
      weight: 3,
      opacity: 0.9,
      zIndex: '1401',
    };
  };

  firedUp = () => {
    const graveId = `grob_${this.state.selected.features[0].properties.id}`;

    if (localStorage.getItem(graveId) !== 'zapalony') {
      localStorage.setItem(graveId, 'zapalony');
      this.setState({
        znicz: true,
      });
    }
  }

  mapRender = () => {
    let zoom = 11;
    const deviceWidth = window.innerWidth;

    let mapStyle;
    if (deviceWidth >= 560) {
      mapStyle = {
        width: '100%',
        height: '600px',
        zIndex: '0',
      };
    } else {
      mapStyle = {
        width: '100%',
        height: 'calc(100vh - 150px)',
        zIndex: '0',
      };
      // zoom = 17;
    }

    const mapa = (
      <div>
        <PaperHeader title="Znajdź grób" />
        <div className="szukajka-grobow">
          <Select
            name="Wyszukaj..."
            value={this.state.label}
            placeholder="wyszukaj..."
            options={arr}
            onChange={(e) => this.handleGrave(e)}
            onBlur={event => event.preventDefault()}
            optionClassName="needsclick"
            blurInputOnSelect={false}
          />
          {(this.state.selected.features.length !== 0) ? (
          <div className="graves-info-list" style={{ width: '100%', marginTop: '20px' }}>
            <ul className="list-group">
              <li className="list-group-item">
                <table>
                  <tr>
                    <td><strong>Imię:</strong></td>
                    <td>{this.state.selected.features[0].properties.imie ? this.state.selected.features[0].properties.imie : 'brak danych'}</td>
                  </tr>
                </table>
              </li>
              <li className="list-group-item">
                <table>
                  <tr>
                    <td><strong>Nazwisko:</strong></td>
                    <td>{this.state.selected.features[0].properties.nazwisko ? this.state.selected.features[0].properties.nazwisko : 'brak danych'}</td>
                  </tr>
                </table>
              </li>
              <li className="list-group-item">
                <table>
                  <tr>
                    <td><strong>Data zgonu:</strong></td>
                    <td>{this.state.selected.features[0].properties.data_zgonu ? this.state.selected.features[0].properties.data_zgonu : 'brak danych'}</td>
                  </tr>
                </table>
              </li>
              <li className="list-group-item">
                <table>
                  <tr>
                    <td><strong>Nr sektora:</strong></td>
                    <td>{this.state.selected.features[0].properties.id_sekt ? this.state.selected.features[0].properties.id_sekt : 'brak danych'}</td>
                  </tr>
                </table>
              </li>
              <li className="list-group-item">
                <table>
                  <tr>
                    <td><strong>Nr rzędu:</strong></td>
                    <td>{this.state.selected.features[0].properties.id_rzedu ? this.state.selected.features[0].properties.id_rzedu : 'brak danych'}</td>
                  </tr>
                </table>
              </li>
              <li className="list-group-item">
                <table>
                  <tr>
                    <td><strong>Uwagi:</strong></td>
                    <td>{this.state.selected.features[0].properties.uwagi ? this.state.selected.features[0].properties.uwagi : 'brak danych'}</td>
                  </tr>
                </table>
              </li>
              <li className="list-group-item">
                <table>
                  <tr>
                    {!this.state.znicz ? <td><strong>Zapal znicz:</strong></td> : null}
                    <td><i onClick={this.firedUp} className={`fa fa-fire fa-3x ${this.state.znicz ? 'znicz-active' : 'znicz'}`}></i></td>
                  </tr>
                </table>
              </li>
            </ul>
          </div>
          ) : null}
        </div>
        <PaperHeader title="Mapa cmentarza" />
        <Map
          ref={m => { this.mapka = m; }}
          center={this.state.center}
          style={mapStyle}
          zoom={zoom}
          animate
        >
          <TileLayer
            url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          />
          <WMSTileLayer
            url={`https://e-spdp.pl/geoserver/${this.state.prefix}/wms?`}
            format={'image/png'}
            transparent
            layers={'granica_gminy'}
          />
          {(this.state.sectors) ? (
            <GeoJSON
              style={this.rzadStyle()}
              data={this.state.sectors}
            />
          ) : null}
          {(this.state.graveyard) ? (
            <GeoJSON
              style={this.graveyardStyle()}
              data={this.state.graveyard}
            />
          ) : null}
          {(this.state.selected.features.length !== 0) ? (
            <GeoJSON
              ref={i => {this.markery = i; }}
              data={this.state.selected}
            >
              <Popup>
                <div>
                  <h3>{this.state.selected.features[0].properties.imie ? this.state.selected.features[0].properties.imie : 'brak danych'}
                    &nbsp;
                    {this.state.selected.features[0].properties.nazwisko ? this.state.selected.features[0].properties.nazwisko : 'brak danych'}
                  </h3>
                  <div>Data zgonu:&nbsp;{this.state.selected.features[0].properties.data_zgonu ? this.state.selected.features[0].properties.data_zgonu : 'brak danych'}</div>
                  <div>Rząd:&nbsp;{this.state.selected.features[0].properties.id_rzedu ? this.state.selected.features[0].properties.id_rzedu : 'brak danych'}</div>
                  <div>Sektor:&nbsp;{this.state.selected.features[0].properties.id_sekt ? this.state.selected.features[0].properties.id_sekt : 'brak danych'}</div>
                </div>
              </Popup>
            </GeoJSON>
          ) : null}
          {/* <WMSTileLayer
            url={'http://37.187.154.62:8080/geoserver/gmina_ropczyce/wms?'}
            format={'image/png'}
            transparent
            layers={'dzialki_ewidencyjne'}
          /> */}
        </Map>
      </div>
    );
    this.mapa = mapa;

    return this.mapa;
  }
  render() {
    return this.state.isMounted ? this.mapRender() : <div className="loader-style" ><img alt="Loader" src={waiting} /></div>
  }
}

Cmentarze.propTypes = {
  fetchGraves: PropTypes.func,
  fetchGraveyard: PropTypes.func,
  fetchSectors: PropTypes.func,
  prefix: PropTypes.string,
  graveyard: PropTypes.object,
};

const mapState = (state) => ({
  graveyard: state.district.graveyard,
  graves: state.district.graves,
  sectors: state.district.sectors,
  districts: state.district.districts
});

// pobiera z reduxa wybrane funkcje typu actions
const mapDispatch = {
  fetchGraves,
  fetchGraveyard,
  fetchSectors,
};

export default withStyles(s)(connect(mapState, mapDispatch)(Cmentarze));



// WEBPACK FOOTER //
// src/routes/urzad/szczegolyUrzedu/Cmentarze.js